import React from "react";

/**
 * Общий блок настроек принтера (IP/Name + тест).
 * Хранение значений — в родителе, чтобы переиспользовать в нескольких вкладках.
 */
const PrinterAccordion = ({
  accordionOpen,
  setAccordionOpen,
  printerIp,
  setPrinterIp,
  printerName,
  setPrinterName,
  onSavePrinterSettings,
  onTestPrint,
}) => {
  return (
    <div className="accordion mb-3" id="printerAccordion">
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingPrinter">
          <button
            className={`accordion-button ${accordionOpen ? "" : "collapsed"}`}
            type="button"
            onClick={() => setAccordionOpen(!accordionOpen)}
            aria-expanded={accordionOpen}
            aria-controls="collapsePrinter"
          >
            Принтер: {printerIp || "IP не задан"} — {printerName || "Имя не задано"}
          </button>
        </h2>
        <div
          id="collapsePrinter"
          className={`accordion-collapse collapse ${accordionOpen ? "show" : ""}`}
          aria-labelledby="headingPrinter"
          data-bs-parent="#printerAccordion"
        >
          <div className="accordion-body">
            <div className="mb-3">
              <label className="form-label">IP адрес</label>
              <input
                type="text"
                className="form-control"
                placeholder="IP"
                value={printerIp}
                onChange={(e) => setPrinterIp(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Имя принтера</label>
              <input
                type="text"
                className="form-control"
                placeholder="Имя принтера"
                value={printerName}
                onChange={(e) => setPrinterName(e.target.value)}
              />
            </div>

            <button className="btn btn-primary me-2" onClick={onSavePrinterSettings}>
              Подключиться
            </button>
            <button className="btn btn-warning" onClick={onTestPrint}>
              Тест печати
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrinterAccordion;
